import { decrypt } from 'features/e2ee/utils/decrypt';
import { base64ToArrayBuffer } from 'features/e2ee/utils/base64';

export const e2eeDecrypt = async (data: string, key: CryptoKey) => {
  const parsedData: {
    cipher: string;
    iv: string;
  } = JSON.parse(data);

  return decrypt(base64ToArrayBuffer(parsedData.cipher), key, base64ToArrayBuffer(parsedData.iv));
};
